import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.x62_1 = $this_channelFlow;
      }
      *y62(it, $completion) {
        yield* this.x62_1.s1a(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.y62(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.y62(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.z62_1 = this$0;
        this.a63_1 = $apolloRequest;
        this.b63_1 = $throwing;
        this.c63_1 = $this_channelFlow;
      }
      *r1f($this$withContext, $completion) {
        var tmp = this.z62_1.d63(this.a63_1, this.b63_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.c63_1);
        yield* tmp.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.r1f($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.e63_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.f63_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.g63_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.h63_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.i63_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.j63_1 = ArrayList().p2();
        this.k63_1 = this.j63_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.l63_1 = ArrayList().p2();
        this.m63_1 = this.l63_1;
        this.n63_1 = Companion_getInstance().u42_1;
        this.o63_1 = null;
        this.p63_1 = null;
        this.q63_1 = null;
        this.r63_1 = null;
        this.s63_1 = null;
        this.t63_1 = null;
        this.u63_1 = null;
        this.v63_1 = null;
        this.w63_1 = null;
        this.x63_1 = null;
        this.y63_1 = null;
        this.z63_1 = null;
        this.a64_1 = null;
        this.b64_1 = null;
        this.c64_1 = null;
        this.d64_1 = null;
        this.e64_1 = null;
        this.f64_1 = null;
        this.g64_1 = null;
        this.h64_1 = null;
        this.i64_1 = null;
        this.j64_1 = null;
        this.k64_1 = null;
        this.l64_1 = true;
      }
      m64() {
        return this.e63_1.p37();
      }
      n64() {
        return plus(plus(plus(this.f63_1, this.g63_1), this.h63_1), this.i63_1);
      }
      h43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.l64_1 = sendEnhancedClientAwareness;
        return this;
      }
      g43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.i64_1 = failFastIfOffline;
        return this;
      }
      o64(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.g64_1 = retryOnError;
        return this;
      }
      p64(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.h64_1 = retryOnErrorInterceptor;
        return this;
      }
      q64(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.j64_1 = cacheInterceptor;
        return this;
      }
      r64(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.k64_1 = autoPersistedQueryInterceptor;
        return this;
      }
      y42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.o63_1 = httpMethod;
        return this;
      }
      z42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.p63_1 = httpHeaders;
        return this;
      }
      b43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.q63_1 = sendApqExtensions;
        return this;
      }
      c43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.r63_1 = sendDocument;
        return this;
      }
      d43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.s63_1 = enableAutoPersistedQueries;
        return this;
      }
      e43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.t63_1 = canBeBatched;
        return this;
      }
      s64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.x63_1 = serverUrl;
        return this;
      }
      t64(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.x63_1 = httpServerUrl;
        return this;
      }
      u64(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.y63_1 = httpEngine;
        return this;
      }
      v64(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.c64_1 = httpExposeErrorBody;
        return this;
      }
      w64(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.j63_1.a5();
        this.j63_1.u2(httpInterceptors);
        return this;
      }
      x64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.z63_1 = webSocketServerUrl;
        return this;
      }
      y64(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.f64_1 = webSocketServerUrl;
        return this;
      }
      z64(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.a64_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      a65(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.b64_1 = wsProtocolFactory;
        return this;
      }
      b65(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.d64_1 = webSocketEngine;
        return this;
      }
      c65(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.e64_1 = webSocketReopenWhen;
        return this;
      }
      d65(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.u63_1 = networkTransport;
        return this;
      }
      e65(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.v63_1 = subscriptionNetworkTransport;
        return this;
      }
      f65(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.e63_1.a5();
        this.e63_1.k46(customScalarAdapters);
        return this;
      }
      g65(listeners) {
        // Inline function 'kotlin.apply' call
        this.l63_1.a5();
        this.l63_1.u2(listeners);
        return this;
      }
      h65(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.w63_1 = dispatcher;
        return this;
      }
      w42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.n63_1 = executionContext;
        return this;
      }
      p37() {
        return new (ApolloClient())(this.k38());
      }
      k38() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).f65(this.e63_1.p37());
        this_0.f63_1.u2(this.f63_1);
        this_0.g63_1.u2(this.g63_1);
        this_0.h63_1.u2(this.h63_1);
        this_0.i63_1.u2(this.i63_1);
        return this_0.h65(this.w63_1).w42(this.n63_1).y42(this.o63_1).z42(this.p63_1).t64(this.x63_1).u64(this.y63_1).v64(this.c64_1).w64(this.k63_1).b43(this.q63_1).c43(this.r63_1).d43(this.s63_1).e43(this.t63_1).d65(this.u63_1).e65(this.v63_1).x64(this.z63_1).y64(this.f64_1).b65(this.d64_1).c65(this.e64_1).z64(this.a64_1).a65(this.b64_1).o64(this.g64_1).p64(this.h64_1).q64(this.j64_1).r64(this.k64_1).g43(this.i64_1).g65(this.m63_1).h43(this.l64_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.i65_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.i65_1(value, $completion);
      }
      i5() {
        return this.i65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.j65_1 = this$0;
        this.k65_1 = $apolloRequest;
        this.l65_1 = $throwing;
      }
      *m65($this$channelFlow, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.j65_1.l62_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.n65(this.k65_1);
        }
        try {
          yield* withContext(this.j65_1.b62_1.o65_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.j65_1, this.k65_1, this.l65_1, $this$channelFlow), $completion);
        }finally {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = this.j65_1.l62_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            element_0.q65(this.k65_1);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.m65((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.m65($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *y62(response, $completion) {
        if (!(response.s44_1 == null)) {
          throw ensureNotNull(response.s44_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.y62(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.y62(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.a62_1 = builder;
        this.e62_1 = this.a62_1.n64();
        this.f62_1 = this.a62_1.m64();
        this.g62_1 = this.a62_1.j64_1;
        this.h62_1 = this.a62_1.k64_1;
        this.i62_1 = this.a62_1.g64_1;
        this.j62_1 = this.a62_1.h64_1;
        this.k62_1 = this.a62_1.i64_1;
        this.l62_1 = this.a62_1.m63_1;
        this.m62_1 = this.a62_1.l64_1;
        this.n62_1 = this.a62_1.n63_1;
        this.o62_1 = this.a62_1.o63_1;
        this.p62_1 = this.a62_1.p63_1;
        this.q62_1 = this.a62_1.q63_1;
        this.r62_1 = this.a62_1.r63_1;
        this.s62_1 = this.a62_1.s63_1;
        this.t62_1 = this.a62_1.t63_1;
        var tmp = this;
        var tmp_0;
        if (!(this.a62_1.u63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.x63_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.y63_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.a62_1.k63_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.c64_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.a62_1.u63_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.a62_1.x63_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).s64(ensureNotNull(this.a62_1.x63_1));
          if (!(this.a62_1.y63_1 == null)) {
            this_0.x65(ensureNotNull(this.a62_1.y63_1));
          }
          if (!(this.a62_1.c64_1 == null)) {
            this_0.y65(ensureNotNull(this.a62_1.c64_1));
          }
          tmp_0 = this_0.z65(this.a62_1.k63_1).p37();
        }
        tmp.c62_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.a62_1.v63_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.z63_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.d64_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.a64_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.b64_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.e64_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a62_1.f64_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.a62_1.v63_1);
        } else {
          var tmp0_elvis_lhs = this.a62_1.z63_1;
          var url = tmp0_elvis_lhs == null ? this.a62_1.x63_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.c62_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).s64(url);
            if (!(this.a62_1.d64_1 == null)) {
              this_1.g66(ensureNotNull(this.a62_1.d64_1));
            }
            if (!(this.a62_1.a64_1 == null)) {
              this_1.h66(ensureNotNull(this.a62_1.a64_1));
            }
            if (!(this.a62_1.b64_1 == null)) {
              this_1.i66(ensureNotNull(this.a62_1.b64_1));
            }
            if (!(this.a62_1.e64_1 == null)) {
              this_1.j66(this.a62_1.e64_1);
            }
            if (!(this.a62_1.f64_1 == null)) {
              this_1.k66(this.a62_1.f64_1);
            }
            tmp_3 = this_1.p37();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.d62_1 = tmp_2;
        var tmp1_elvis_lhs = this.a62_1.w63_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.b62_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.u62_1 = new (NetworkInterceptor())(this.c62_1, this.d62_1);
      }
      l66(query) {
        return ApolloCall().y61(this, query);
      }
      m66(mutation) {
        return ApolloCall().y61(this, mutation);
      }
      l6() {
        cancel(this.b62_1.p65_1);
        this.c62_1.jz();
        this.d62_1.jz();
      }
      v62(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().y12_1), 2147483647);
      }
      d63(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.v43();
        this_0.w42(this.b62_1.i44(this.f62_1).i44(apolloClient.n62_1).i44(this_0.j42_1));
        var tmp0_elvis_lhs = this_0.k42_1;
        this_0.y42(tmp0_elvis_lhs == null ? apolloClient.o62_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.n42_1;
        this_0.b43(tmp1_elvis_lhs == null ? apolloClient.q62_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.o42_1;
        this_0.c43(tmp2_elvis_lhs == null ? apolloClient.r62_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.m42_1;
        this_0.d43(tmp3_elvis_lhs == null ? apolloClient.s62_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.q42_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.p62_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.l42_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.z42(headers);
        var tmp4_elvis_lhs = this_0.p42_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.t62_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.a43('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.r42_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.i62_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.f43(tmp);
        var tmp7_elvis_lhs = this_0.s42_1;
        this_0.g43(tmp7_elvis_lhs == null ? apolloClient.k62_1 : tmp7_elvis_lhs);
        this_0.h43(apolloClient.m62_1);
        var request = this_0.p37();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.a62_1.f63_1);
        if (!(this.g62_1 == null)) {
          this_2.i2(this.g62_1);
        }
        this_2.u2(this.a62_1.g63_1);
        if (!(this.h62_1 == null)) {
          this_2.i2(this.h62_1);
        }
        this_2.u2(this.a62_1.h63_1);
        var tmp0_elvis_lhs_2 = this.j62_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.a62_1.i63_1);
        this_2.i2(this.u62_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).p66(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
